/**
 * Returns true if any matching RTK Query mutation is still pending
 */
export const hasPendingMutations = (state: any, { endpointNames }: PendingMutationOptions): boolean => {
  const names = Array.isArray(endpointNames) ? endpointNames : [endpointNames]

  const mutations = state.api?.mutations ?? state.reminderApi?.mutations ?? state.projectApi?.mutations ?? {}

  return Object.values(mutations).some(
    (mutation: any) => names.includes(mutation?.endpointName) && mutation?.status === "pending"
  )
}
// !IMPORTANT: DONOT USE getQueryArgsByEndpoint for new code, use getQueryArgsByEndpoints instead and update usages of getQueryArgsByEndpoint accordingly.
// UpdateTodoResponsible is the only current usage for getQueryArgsByEndpoints,
// so we can take that as an example of how to update other usages in the future
/**
 * Returns the original query arguments for a given RTK Query endpoint substring
 * Useful for optimistic updates where you need to access the current query args
 */
export const getQueryArgsByEndpoint = (getState: () => any, endpointSubstring: string): { args: any; entry: any } => {
  const state = getState() as any
  // Support both RTK Query slices
  const queries = state.api?.queries ?? state.calendarEventApi?.queries ?? {}

  const queryKey = Object.keys(queries).find((key) => queries[key]?.endpointName.includes(endpointSubstring))

  if (queryKey) {
    const entry = queries[queryKey]
    const args = entry?.originalArgs
    return { args, entry }
  }
  return { args: undefined, entry: undefined }
}

/**
 * Returns all original query arguments for a given RTK Query endpoint substring
 */
export const getQueryArgsByEndpoints = (
  getState: () => any,
  endpointSubstring: string
): { args: any; entry: any }[] => {
  const state = getState() as any

  const queries = state.api?.queries ?? state.calendarEventApi?.queries ?? {}

  return Object.keys(queries)
    .filter((key) => queries[key]?.endpointName.includes(endpointSubstring))
    .map((key) => {
      const entry = queries[key]

      return {
        args: entry?.originalArgs,
        entry,
      }
    })
}
type PendingMutationOptions = {
  endpointNames: string | string[]
}
